<mat-chip
  [matTooltip]="placeholders[0] || ''"
  (click)="$event.stopPropagation()"
  (focus)="$event.stopPropagation()"
  [disabled]="loading"
  [removable]="
    (isChipOptional() ||
      isChipPreselected() ||
      isChipChiningParams() ||
      isChipDefault()) &&
    !loading
  "
  (removed)="remove(selectedData)"
  attr.data-testid="cis_date_{{
    selectedData?.name?.toLowerCase()?.replace(' ', '_')
  }}"
  >
  <div
    style="display: none"
    #hiddenLabel
    class="label"
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_label"
    >
    {{ selectedData?.name ?? '' | translate }}
  </div>

  @if (pickerMode === 'year-month-date') {
    <cis-date-chip-year-month-date-picker-search-filter
      [loading]="loading"
      [isChipLock]="isChipLock()"
    [inputWidth]="
      getInputWidth(date.value?.toString()?.length ?? 0, hiddenLabel)
    "
      [formControl]="date"
      [placeholder]="placeholders[0]"
      [disabled]="isChipLock() || loading"
      [readonly]="isChipChiningParams() || isChipLock()"
      [label]="selectedData?.name ?? '' | translate"
      [openPicker]="openPicker.asObservable()"
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_year_month_date"
    ></cis-date-chip-year-month-date-picker-search-filter>
  }

  @if (pickerMode === 'year-month') {
    <cis-date-chip-year-month-picker-search-filter
      [loading]="loading"
      [isChipLock]="isChipLock()"
    [inputWidth]="
      getInputWidth(date.value?.toString()?.length ?? 0, hiddenLabel)
    "
      [formControl]="date"
      [placeholder]="placeholders[0]"
      [disabled]="isChipLock() || loading"
      [readonly]="isChipChiningParams() || isChipLock()"
      [label]="selectedData?.name ?? '' | translate"
      [openPicker]="openPicker.asObservable()"
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_year_month"
    ></cis-date-chip-year-month-picker-search-filter>
  }

  @if (pickerMode === 'year') {
    <cis-date-chip-year-picker-search-filter
      [loading]="loading"
      [isChipLock]="isChipLock()"
    [inputWidth]="
      getInputWidth(date.value?.toString()?.length ?? 0, hiddenLabel)
    "
      [formControl]="date"
      [placeholder]="placeholders[0]"
      [disabled]="isChipLock() || loading"
      [readonly]="isChipChiningParams() || isChipLock()"
      [label]="selectedData?.name ?? '' | translate"
      [openPicker]="openPicker.asObservable()"
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_year"
    ></cis-date-chip-year-picker-search-filter>
  }

  @if (
    isChipOptional() ||
    isChipPreselected() ||
    isChipChiningParams() ||
    isChipDefault()
    ) {
    <mat-icon
      matChipRemove
      [style.cursor]="loading ? 'context-menu' : 'pointer'"
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_btn_cancel"
      >cancel</mat-icon
      >
    }
    @if (isChipMandatory()) {
      <mat-icon
        style="vertical-align: text-top; cursor: default"
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_icon_mandatory"
        >push_pin
      </mat-icon>
    }
    @if (isChipLock()) {
      <mat-icon
    attr.data-testid="cis_date_{{
      selectedData?.name?.toLowerCase()?.replace(' ', '_')
    }}_icon_locked"
        style="vertical-align: text-top; cursor: default"
        >lock</mat-icon
        >
      }
    </mat-chip>
